'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SIZE_MAP = exports.WEIGHT_MAP = exports.TEXT_SIZE = undefined;

var _enum = require('../../utils/enum');

var _enum2 = _interopRequireDefault(_enum);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TEXT_SIZE = exports.TEXT_SIZE = new _enum2.default({
  TINY: {
    value: 'tiny'
  },
  EXTRA_SMALL: {
    value: 'extra-small'
  },
  SMALL: {
    value: 'small'
  },
  MEDIUM: {
    value: 'medium'
  },
  LARGE: {
    value: 'large'
  },
  EXTRA_LARGE: {
    value: 'extra-large'
  }
}); // deprecated

var WEIGHT_MAP = exports.WEIGHT_MAP = {
  light: 300,
  normal: 400,
  medium: 500,
  'semi-bold': 600
};

var SIZE_MAP = exports.SIZE_MAP = {
  'extra-extra-small': 10,
  'extra-small': 12,
  small: 14,
  medium: 16,
  large: 18,
  'extra-large': 24,
  'extra-extra-large': 32,
  'extra-extra-extra-large': 32
};


//////////////////
// WEBPACK FOOTER
// ./~/@kalo/ui/lib/components/text/constants.js
// module id = 197
// module chunks = 114276838955818